import React, { useEffect } from 'react';
import { COMMAND_PALETTE_REGISTRY_IDS } from '@atlassian/jira-command-palette-registry/src/common/constants/registry/index.tsx';
import { useSubscribeCommands } from '@atlassian/jira-command-palette-registry/src/controllers/use-subscribe-commands/index.tsx';
import { QuickSearchWrapper } from '../controllers/use-quick-search-analytics/wrapper';
import { useQuickSearchCommand } from './use-quick-search-command';

const useQuickSearchCommands = () => {
	const subscribe = useSubscribeCommands();
	const { quickSearchCommand } = useQuickSearchCommand({ keepSearch: false });

	useEffect(
		() => subscribe(COMMAND_PALETTE_REGISTRY_IDS.QUICK_SEARCH, [quickSearchCommand]),
		[quickSearchCommand, subscribe],
	);

	return null;
};

const QuickSearchCommandsInner = () => {
	useQuickSearchCommands();
	return null;
};

export const QuickSearchCommands = () => (
	<QuickSearchWrapper>
		<QuickSearchCommandsInner />
	</QuickSearchWrapper>
);
